import { VCol } from 'vuetify/lib/components/VGrid';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VParallax,{attrs:{"src":require("@/assets/slide_silam.jpg")}},[_c(VRow,{attrs:{"align":"center","justify":"center"}},[_c(VCol,{staticClass:"text-center",attrs:{"cols":"12"}},[_c('h1',{staticClass:"text-h4 mb-4"},[_vm._v(" SILAM ")]),_c('h4',{staticClass:"subheading"},[_vm._v(" Silicone Solutions Leader ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }